import { useDispatch, useSelector } from "react-redux";
import ChangeLog from "./ChangeLog";
import changeLogColumn from "../../../../utils/changeLogColumns"

import { getFleetAfeChangeLog, getFleetAssetChangeLog } from "Store/FleetManagement/FleetAssetChangeLog/FleetAssetChangeLogAction";
import { CONSTANTS } from "client/utils/constants";

const ChangeLogContainer = (props: any) => {
  const dispatch = useDispatch();
  const fleetDetailId = props?.fleetRequestDetailId;

  const { fleetAssetChangeLog, fleetAfeChangeLog, assetOrderHeaderDetail }: any = useSelector((state: any) => ({
    fleetAssetChangeLog: state.FleetAssetChangeLogReducer.fleetAssetChangeLog,
    fleetAfeChangeLog: state.FleetAssetChangeLogReducer.fleetAfeChangeLog,
    assetOrderHeaderDetail: state.AssetFleetProcessingReducer.assetOrderHeaderDetail,
  }));

  const fleetAssetChangeLogvalue = (id?: any) => {
    if (fleetAssetChangeLog?.length) {
      let val = fleetAssetChangeLog?.filter((logItem?: any) => logItem?.id == id)
      return val[0]?.response;
    }
  }

  const fleetAfeChangeLogvalue = (id?: any) => {
    if (fleetAfeChangeLog?.length) {
      let val = fleetAfeChangeLog?.filter((logItem?: any) => logItem?.id == id)
      return val[0]?.response;
    }
  }

  const onExpandChangeLog = () => {
    if (fleetDetailId) {
      if (assetOrderHeaderDetail?.orderRequestType === CONSTANTS.AFEREQUEST) {
        dispatch(getFleetAfeChangeLog(fleetDetailId));
      } else {
        dispatch(getFleetAssetChangeLog(fleetDetailId));
      }
    }
  }

  return (
    <ChangeLog
      Data={assetOrderHeaderDetail?.orderRequestType === CONSTANTS.AFEREQUEST ? fleetAfeChangeLogvalue(fleetDetailId) : fleetAssetChangeLogvalue(fleetDetailId)}
      changeLogColumn={changeLogColumn} activeStepper={props?.activeStepper}
      onExpandChangeLog={onExpandChangeLog}
    />
  )
}

export default ChangeLogContainer;